import React, { ComponentPropsWithoutRef } from 'react';

type ImageViewerProps = Omit<ComponentPropsWithoutRef<'img'>, 'src'> & {
  src?: string | null;
  spinner?: React.ReactNode;
  fileErrorIndicator?: React.ReactNode;
  isError?: boolean;
  isLoading?: boolean;
};

export const ImageViewer = ({
  spinner,
  fileErrorIndicator,
  isError = false,
  isLoading = false,
  src,
  ...props
}: ImageViewerProps) => {
  const [innerLoading, setInnerLoading] = React.useState(false);
  const [innerError, setInnerError] = React.useState(false);

  const showSpinner = isLoading || innerLoading;
  const showFileError = isError || innerError;

  return (
    <>
      {showFileError && fileErrorIndicator}
      {showSpinner && spinner}
      <img
        src={src ?? undefined}
        onLoadStart={() => setInnerLoading(true)}
        onError={() => setInnerError(true)}
        onLoad={() => setInnerLoading(false)}
        style={{ display: showSpinner || showFileError ? 'none' : undefined }}
        {...props}
      />
    </>
  );
};
